"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StoreEvent {
    constructor() {
        this.eventHandlers = new Map();
    }
    sendEvent(type, event) {
        const eventType = type;
        if (this.eventHandlers.has(eventType)) {
            const eventTypeHandler = this.eventHandlers.get(eventType);
            if (eventTypeHandler !== undefined) {
                eventTypeHandler.forEach((handler) => {
                    handler(event);
                });
            }
        }
    }
    addEventHandler(type, handler) {
        const eventType = type;
        if (this.eventHandlers.has(eventType)) {
            const eventTypeHandler = this.eventHandlers.get(eventType);
            if (eventTypeHandler) {
                eventTypeHandler.push(handler);
            }
        }
        else {
            this.eventHandlers.set(eventType, [handler]);
        }
    }
}
exports.StoreEvent = StoreEvent;
exports.default = new StoreEvent();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmVFdmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInN0b3JlRXZlbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFRQSxNQUFhLFVBQVU7SUFHbkI7UUFDSSxJQUFJLENBQUMsYUFBYSxHQUFHLElBQUksR0FBRyxFQUFnQyxDQUFDO0lBQ2pFLENBQUM7SUFDTSxTQUFTLENBQUMsSUFBWSxFQUFFLEtBQWtCO1FBQzdDLE1BQU0sU0FBUyxHQUFHLElBQWMsQ0FBQztRQUNqQyxJQUFJLElBQUksQ0FBQyxhQUFhLENBQUMsR0FBRyxDQUFDLFNBQVMsQ0FBQyxFQUFFO1lBQ3JDLE1BQU0sZ0JBQWdCLEdBQUcsSUFBSSxDQUFDLGFBQWEsQ0FBQyxHQUFHLENBQUMsU0FBUyxDQUFDLENBQUM7WUFDM0QsSUFBSSxnQkFBZ0IsS0FBSyxTQUFTLEVBQUU7Z0JBQ2xDLGdCQUFnQixDQUFDLE9BQU8sQ0FBQyxDQUFDLE9BQU8sRUFBRSxFQUFFO29CQUNuQyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUM7Z0JBQ2pCLENBQUMsQ0FBQyxDQUFDO2FBQ0o7U0FDRjtJQUNILENBQUM7SUFDTSxlQUFlLENBQUMsSUFBWSxFQUFFLE9BQTJCO1FBQzlELE1BQU0sU0FBUyxHQUFHLElBQWMsQ0FBQztRQUNqQyxJQUFJLElBQUksQ0FBQyxhQUFhLENBQUMsR0FBRyxDQUFDLFNBQVMsQ0FBQyxFQUFFO1lBQ3JDLE1BQU0sZ0JBQWdCLEdBQUcsSUFBSSxDQUFDLGFBQWEsQ0FBQyxHQUFHLENBQUMsU0FBUyxDQUFDLENBQUM7WUFDM0QsSUFBSSxnQkFBZ0IsRUFBRTtnQkFDcEIsZ0JBQWdCLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDO2FBQ2hDO1NBQ0Y7YUFBTTtZQUNMLElBQUksQ0FBQyxhQUFhLENBQUMsR0FBRyxDQUFDLFNBQVMsRUFBRSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7U0FDOUM7SUFDSCxDQUFDO0NBQ047QUE1QkQsZ0NBNEJDO0FBRUQsa0JBQWUsSUFBSSxVQUFVLEVBQUUsQ0FBQyJ9